import { Descriptions, Divider } from 'antd';
import _ from 'lodash';
import React from 'react';
import nextId from 'react-id-generator';
import { useTranslation } from 'react-i18next';
import { PaymentData } from '../../../store/interestStorage';
import { DescFullWidth, RowExt } from '../../../styles';
import { formatDate } from '../../../utils/helpers/date';
import { formatPLN } from '../../../utils/helpers/formatNumber';
import { shortenString } from '../../Lawsuit/StepCards/InterestForm/InterestFormTable';


const { Item: DescItem } = Descriptions;

const DetailsPayments = ({
  assignedPayments,
  assignedPaymentsSum,
  claimKey,
  interestsSumFulfilledCovered,
  interestsSumCovered,
}:{
  assignedPayments: PaymentData,
  assignedPaymentsSum: number,
  interestsSumCovered: number,
  claimKey: string,
  interestsSumFulfilledCovered: number,
}) => {
  const { t } = useTranslation();

  if (_.isEmpty(assignedPayments)) return null;

  return (
    <>
      <Divider>{t('detailsPayments.title')}</Divider>
      <DescFullWidth layout="horizontal" bordered key="d">
        <DescItem
          label={t('detailsPayments.total')}
          span={3}
          labelStyle={{ fontWeight: 700 }}
        >
          <strong>
            {`${formatPLN(assignedPaymentsSum)}`}
          </strong>
        </DescItem>
        <DescItem label={t('detailsPayments.main')} span={3}>
          <strong>
            {`${formatPLN(assignedPaymentsSum - (interestsSumFulfilledCovered + interestsSumCovered))}`}
          </strong>
        </DescItem>
        <DescItem label={t('detailsPayments.interest')} span={3}>
          <strong>
            {`${formatPLN(interestsSumFulfilledCovered + interestsSumCovered)}`}
          </strong>
        </DescItem>
      </DescFullWidth>
      <Divider />
      {assignedPayments.map(value =>
        (
          <RowExt marginTop="md" fullWidth key={nextId()}>
            <DescFullWidth layout="horizontal" bordered key="d">
              <DescItem label={t('PaymentDate')} span={3}>{formatDate(value.paymentDate)}</DescItem>
              {_.isNull(value.statementDate) ? null :
              <DescItem label={t('SatementDate')} span={3}>{formatDate(value.statementDate)}</DescItem>}
              <DescItem label={t('PaymentSum')} span={3}>
                {`${formatPLN(value.paymentSum)}`}
              </DescItem>
              <DescItem
                label={(
                  <>
                    {t('detailsPayments.portion')}
                    {' '}
                    <strong>
                      {t('detailsPayments.credited')}
                    </strong>
                  </>
)}
                span={3}
              >
                <strong>
                  {formatPLN(value.assignedTo.find(_val =>
                    _val.key === claimKey)?.sum ?? 0)}
                </strong>
              </DescItem>
              <DescItem label={t('detailsPayments.first')} span={3}>
                {(value.assignedTo.find(_val =>
                  _val.key === claimKey)?.isInterestFirst) ?
                  'tak' : 'nie'}
              </DescItem>
              {_.isNull(value.transferDescription) ? null :
              <DescItem label={t('SatementDate')} span={3}>{shortenString(value.transferDescription)}</DescItem>}
            </DescFullWidth>
          </RowExt>
        )) }
    </>
  );
};

export default DetailsPayments;